//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prePayments', {
//        templateUrl: 'views/components/views/prePayments/prePayments.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prePaymentsService', function ($stateParams, stateService, prePaymentsService) {
//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                setting: {},
//                itemsListPrePayments: []
//            };

//            async function loadSetting() {
//                vm.model.setting = (await prePaymentsService.getPrePaymentSum({
//                    argtype: argType,
//                    argvalue: argValue
//                }))[0];
//            }

//            async function loadPrePayments() {
//                vm.model.itemsListPrePayments = await prePaymentsService.listPrePayments({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'prepayment':
//                        go({
//                            argtype: argType,
//                            argvalue: argValue,
//                            prepayment_keyno: '0'
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//            vm.$onInit = async function () {
//                loadSetting();
//                loadPrePayments();
//            }
//        }]
//    });
//})();
